module.exports = __webpack_public_path__ + "6d7a6dbb3703a7a0af8e29e97e36d7ce.webp";